<div class="modal-header" *ngIf="step!=5">
	<h5 class="modal-title">Registreren op {{systemTitle}}</h5>
	<button type="button" class="close" aria-label="Close" (click)="close()">
		<span aria-hidden="true">&times;</span>
	</button>
</div>
<div class="modal-body pt-5 px-5 pb-4" style="max-width: 800px;">
	<section>
		<div *ngIf="!successmessage">

			<div class="step-0" *ngIf="step==0">
				<h1>Hoi! Welkom op {{systemTitle}}</h1>
				<p class="lead">Om gebruik te maken van deze lesmethode, moeten we ons eerst registreren. Dat gaan we nu doen.</p>
				<p>Wil je straks inloggen via Entree, of via {{systemTitle}}? Vraag het aan de docent als je dit niet weet.</p>

				<div class="registerOptions">
					<a href="{{apiUrl}}authentication"><img class="entreeButton"
							src="assets/images/entree_button_licht_440x80.png"></a>
					<div class="sep">
						<span class="or">OF</span>
					</div>
					<button (click)="checkStep0()" class="btn btn-success">
						<span>Inloggen via {{systemTitle}}</span>
					</button>
				</div>
			</div>

			<div class="step-1" *ngIf="step==1">
				<h1 class="display-6 font-weight-bold">In welke klas zit jij?</h1>
				<p class="lead">Vul hieronder je klascode in die je van de docent hebt gekregen.</p>

				<div class="alert alert-success" *ngIf="successmessage">Wijzigingen succesvol opgeslagen.</div>
				<div class="alert alert-danger" *ngIf="errormessage" [innerHTML]="errormessage"></div>

				<div class="form-group">
					<div class="classroom-code-container">
						<input type="text" id="classroomCode1" class="classroom-code classroom-code-1"
							[ngClass]="{'border-success':classroomCode1.length > 0}" (paste)="onCodePaste($event)"
							(keyup)="checkCodeInput($event)" maxLength="1" [(ngModel)]="classroomCode1"
							value="{{classroomCode1}}" />
						<input type="text" id="classroomCode2" class="classroom-code classroom-code-2"
							[ngClass]="{'border-success':classroomCode2.length > 0}" (paste)="onCodePaste($event)"
							(keyup)="checkCodeInput($event)" maxLength="1" [(ngModel)]="classroomCode2"
							value="{{classroomCode2}}" />
						<input type="text" id="classroomCode3" class="classroom-code classroom-code-3"
							[ngClass]="{'border-success':classroomCode3.length > 0}" (paste)="onCodePaste($event)"
							(keyup)="checkCodeInput($event)" maxLength="1" [(ngModel)]="classroomCode3"
							value="{{classroomCode3}}" />
						<input type="text" id="classroomCode4" class="classroom-code classroom-code-4"
							[ngClass]="{'border-success':classroomCode4.length > 0}" (paste)="onCodePaste($event)"
							(keyup)="checkCodeInput($event)" maxLength="1" [(ngModel)]="classroomCode4"
							value="{{classroomCode4}}" />
						<input type="text" id="classroomCode5" class="classroom-code classroom-code-5"
							[ngClass]="{'border-success':classroomCode5.length > 0}" (paste)="onCodePaste($event)"
							(keyup)="checkCodeInput($event)" maxLength="1" [(ngModel)]="classroomCode5"
							value="{{classroomCode5}}" />
						<input type="text" id="classroomCode6" class="classroom-code classroom-code-6"
							[ngClass]="{'border-success':classroomCode6.length > 0}" (paste)="onCodePaste($event)"
							(keyup)="checkCodeInput($event)" maxLength="1" [(ngModel)]="classroomCode6"
							value="{{classroomCode6}}" />
						<input type="text" id="classroomCode7" class="classroom-code classroom-code-7"
							[ngClass]="{'border-success':classroomCode7.length > 0}" (paste)="onCodePaste($event)"
							(keyup)="checkCodeInput($event)" maxLength="1" [(ngModel)]="classroomCode7"
							value="{{classroomCode7}}" />
						<input type="text" id="classroomCode8" class="classroom-code classroom-code-8"
							[ngClass]="{'border-success':classroomCode8.length > 0}" id="classroom-code-8"
							(paste)="onCodePaste($event)" (keyup)="checkCodeInput($event)" maxLength="1"
							[(ngModel)]="classroomCode8" value="{{classroomCode8}}" />
					</div>
				</div>

				<button (click)="checkStep1()" class="btn btn-success">
					<span>Volgende stap</span>
				</button>
			</div>
			<div class="step-2" *ngIf="step==2">
				<h1 class="display-6 fontWeightNormal">
					Zo te zien zit je in <span class="highlight font-weight-bold">{{classroomName}}</span> van de school <span
						class="highlight font-weight-bold">{{organisationName}}</span>. Klopt dat?
					<button (click)="toStep1()" class="btn btn-danger">
						<span>Nee, terug!</span>
					</button>
				</h1>

				<p class="lead mt-3 mb-3">Vul hieronder je (school)e-mailadres in en eventueel je naam.</p>

				<div class="alert alert-success" *ngIf="successmessage">Wijzigingen succesvol opgeslagen.</div>
				<div class="alert alert-danger" *ngIf="errormessage" [innerHTML]="errormessage"></div>
				<div class="form-group">
					<label for="name">Naam</label>
					<input type="text" class="form-control" [(ngModel)]="name" value="{{name}}" />
					<div class="error" *ngIf="errors.name">{{errors.name}}</div>
				</div>
				<div class="form-group">
					<label for="email">E-mailadres</label>
					<input id="email"
						[ngClass]="{ 'is-invalid': errorEmailRequired || errorInvalidEmail || errorInvalidEmailTld , 'is-valid': emailValid }"
						[(ngModel)]="email" (blur)="checkEmail($event)" class="form-control" type="text"
						class="form-control" [(ngModel)]="email" value="{{email}}" />
					<div *ngIf="errorInvalidEmail" class="invalid-feedback">
						Dit lijkt geen echt e-mailadres te zijn, kijk eens goed.
					</div>
					<div *ngIf="errorInvalidEmailTld" class="invalid-feedback">
						Het lijkt erop dat je een ongeldige domeinnaam hebt ingevoerd. Een e-mailadres eindigt op
						.{{allowedTld.join(', .')}}.
					</div>
				</div>
				<button (click)="checkStep2()" class="btn btn-success">
					<span>Volgende stap</span>
				</button> &nbsp;
				<button (click)="toStep1()" class="btn btn-info">
					<span>Terug</span>
				</button>
			</div>
			<div class="step-3" *ngIf="step==3">
				<h1 class="display-6 font-weight-bold">Perfect! We zijn er bijna.</h1>

				<p class="lead">Vul tenslotte een wachtwoord in, maar denk eraan: hij moet niet te makkelijk zijn hè.
				</p>

				<div class="alert alert-success" *ngIf="successmessage">Wijzigingen succesvol opgeslagen.</div>
				<div class="alert alert-danger" *ngIf="errormessage" [innerHTML]="errormessage"></div>

				<div class="form-group">
					<label for="email">Wachtwoord</label>
					<input type="password" class="form-control" (blur)="checkPassword($event)"
						(keyup)="checkPassword($event)"
						[ngClass]="{ 'is-invalid': errorPasswordRequired || errorInvalidPassword, 'is-valid': passwordValid }"
						[(ngModel)]="password" value="{{password}}" />
					<div class="error invalid-feedback" *ngIf="errorPasswordRequired">Vul minimaal 4 tekens in.</div>
					<div class="error invalid-feedback" *ngIf="errors.password">{{errors.password}}</div>
				</div>
				<div class="form-group">
					<label for="email">Herhaal wachtwoord</label>
					<input type="password" class="form-control" (blur)="checkRepeatPassword($event)"
						(keyup)="checkRepeatPassword($event)" [(ngModel)]="repeatPassword"
						[ngClass]="{ 'is-invalid': repeatPasswordInvalid, 'is-valid': repeatPasswordValid }"
						value="{{repeatPassword}}" />
					<div class="invalid-feedback" *ngIf="repeatPasswordInvalid">Je wachtwoorden komen niet overeen.
					</div>
				</div>
				<button (click)="checkStep3()" class="btn btn-success">
					<span>Laatste stap</span>
				</button> &nbsp;
				<button (click)="toStep2()" class="btn btn-info">
					<span>Terug</span>
				</button>
			</div>
			<div class="step-4" *ngIf="step==4">
				<div class="alert alert-danger" *ngIf="errormessage" [innerHTML]="errormessage"></div>
				<h1 class="display-5 font-weight-bold">Check, check, dubbelcheck!</h1>
				<dl class="mt-3">
					<dt>School:</dt>
					<dd>{{organisationName}}</dd>
					<dt>Klas:</dt>
					<dd>{{classroomName}}</dd>
					<dt *ngIf="name">Je naam bij ons:</dt>
					<dd *ngIf="name">{{name}}</dd>
					<dt>Je e-mailadres bij ons:</dt>
					<dd>{{email}}</dd>
				</dl>

				<p style="font-weight: bold;">Tevreden?</p>
				<button (click)="save()" class="btn btn-success">
					<span>Alles klopt! Meld mij aan</span>
				</button> &nbsp;
				<button (click)="toStep3()" class="btn btn-info">
					<span>Terug</span>
				</button>
			</div>
			<div class="step-5" *ngIf="step==5">
				<p><img [src]="''+cdnUrl+'images/register_succeed.gif'" class="img-fluid"
						alt="Een overdreven plaatje dat je bent aangemeld op {{systemTitle}}" /></p>
				<p class="lead">Yaaay! Je bent aangemeld en we gaan je direct inloggen.</p>
			</div>
		</div>
		<div class="py-3">
			<small class="text-small">Wil je weten hoe {{systemTitle}} omgaat met je persoonsgegevens? <a
					href="https://uitgeverijneo.nl/blog/privacy-by-design-hoe-neo-omgaat-met-persoonsgegevens" target="_blank">Lees hierover in onze blog.</a></small>
		</div>
	</section>
</div>